/* eslint-disable jsx-a11y/heading-has-content */
import classNames from 'classnames';
import * as React from 'react';
const Title = ({ prefixCls, className, width, style }) => (React.createElement("h3", { className: classNames(prefixCls, className), style: Object.assign({ width }, style) }));
export default Title;
